import { Coordinates } from './../../../../models/coordinates.model';

import { Component, Input, IterableDiffers, DoCheck } from '@angular/core';

import * as L from 'leaflet';
import { LeafletBlockComponent } from '../leaflet-block-component.interface';
import { CryptoRandomFloat } from 'src/app/common/crypto-random-float';

@Component({
    selector: 'leaflet-arc',
    template: '',
    standalone: false
})
export class LeafletArcComponent implements LeafletBlockComponent, DoCheck {
	@Input() public name: string;
	@Input() public isDefault: boolean = true;
	@Input() public includeInOverlays: boolean = true;

	private _data: {
		source: Coordinates,
		destination: Coordinates,
		options: L.PathOptions
	}[];
	@Input()
	public get data(): {
		source: Coordinates,
		destination: Coordinates,
		options: L.PathOptions
	}[] { return this._data; }
	public set data(
		value: {
			source: Coordinates,
			destination: Coordinates,
			options: L.PathOptions
		}[]
	) {
		this._data = value;

		this.updateLayerGroup();
	}

	private _arrowIcon = L.divIcon({
		html: '<i class="fa-solid fa-square-arrow-up fa-1x"></i>',
		iconSize: [20, 20],

		className: 'leaflet-arrow-icon'
	});

	private _layerGroup: any;

	public updateLayerGroup(additively: boolean = false): void {
		if (!this._layerGroup) {
			return;
		}

		if (!additively) {
			this._layerGroup.clearLayers();
		}

		let markers = [];

		for (let a = 0; a < this._data.length; a++) {

			const arcPathData = LeafletArcComponent.getArcPathData(this._data[a].source, this._data[a].destination, 100);

			

			

			let arc: L.Curve = L.curve(
				arcPathData.path,
				this._data[a].options
			);

			const marker = L.marker(
				[
					arcPathData.path[3][0],
					arcPathData.path[3][1]
				],
				{} //Object.assign({}, { icon: this._arrowIcon })
			);

			markers.push(arc);
			markers.push(marker);
		}

		for (let a = 0; a < markers.length; a++) {
			this._layerGroup.addLayer(markers[a]);
		}
	}

	public initialize(layerGroup: L.LayerGroup, map: L.Map) {
		this._layerGroup = layerGroup;

		this.updateLayerGroup();
	}

	private iterableDiffer: any;

	constructor(private _iterableDiffers: IterableDiffers) {
    this.iterableDiffer = this._iterableDiffers.find([]).create(null);
	}

	ngDoCheck(): void {
		let changes = this.iterableDiffer.diff(this._data);
    
		if (changes) {
			

			this.updateLayerGroup();
		}
	}





	public static lerp(a, b, t) {
		if (t > 1) {
			t = 1;
		}

		return a + t * (b - a);
	}


	public static getArcPathData(source: Coordinates, destination: Coordinates, arcFactor: number): { path: any[], animationSpeedFactor: number} {
		
		
		let distance = Math.sqrt(Math.pow(source.latitude - destination.latitude, 2) + Math.pow(source.longitude - destination.longitude, 2));

		

		let midpointX = (source.latitude + destination.latitude) / 2;
		let midpointY = (source.longitude + destination.longitude) / 2;

		let normalizedMidpointX = midpointX / distance;
		let normalizedMidpointY = midpointY / distance;

		let calculatedDistanceFromMidpointToArcMidpoint = this.lerp(0.5, 40, Math.pow(distance / arcFactor, 3));

		let rnd = CryptoRandomFloat.getCryptoRandomFloat();

		let arcMidPoints = [
			midpointX + (rnd <= 0.5 ? normalizedMidpointX : -normalizedMidpointX) * calculatedDistanceFromMidpointToArcMidpoint,
			midpointY + (rnd <= 0.5 ? -normalizedMidpointY : normalizedMidpointY) * calculatedDistanceFromMidpointToArcMidpoint
		];

		return {
			path: [
				'M', [source.latitude, source.longitude],
				'S', arcMidPoints, [destination.latitude, destination.longitude]
			],
			animationSpeedFactor: calculatedDistanceFromMidpointToArcMidpoint
		};
	}
}
